import React, { useState } from 'react';
import { useProcessStatusContext } from './context/ProcessStatusContext';
import Confirm from '../../../../Components/Confirm';
import { Switch } from '../../../../Components/Checkbox/Checkbox';
import { List, ListItem } from '../../../../Components/List';
import { ProcessType } from '../../../../Services/WorkflowServicesTypes';
import { splitWords } from '../../../../Util';
import { Article } from '../../../../Components/Article/Article';

const ProcessRequestConfirmation = () => {
	const {
		availableProcessTypes,
		requestCreationRequested,
		processType,
		handleCloseSynchroRequested,
		startSynchro
	} = useProcessStatusContext();

	const [checkedProcessTypes, setCheckedProcessTypes] = useState<ProcessType[]>([]);

	const related = availableProcessTypes.find(x => x.processType === processType)?.related ?? [];

	const confirm = () => {
		startSynchro(checkedProcessTypes);
		handleCloseSynchroRequested();
	};

	const getProcessTypeSelector = () => <>
		<Article size='s' title='Synchronize these processes too?' titleSize="xs" className='mt_30'>
			<List removeVerticalMargin={true} size='s'>
				{related.map(r => (
					<ListItem key={r}>
						<Switch
							size="s"
							label={splitWords(r)}
							forcedChecked={checkedProcessTypes.includes(r)}
							onChange={() => setCheckedProcessTypes(b => !checkedProcessTypes.includes(r) ? [...b, r] : b.filter(x => x !== r))}
							position='right'
						/>
					</ListItem>
				))}
			</List>
		</Article>
	</>;

	return (<>
		<Confirm
			title={splitWords(processType)}
			text={'Do you want to start synchronization?'}
			confirmCallback={confirm}
			confirmText={'Start'}
			onClose={() => handleCloseSynchroRequested()}
			isOpen={requestCreationRequested}
			width={470}
		>
			{getProcessTypeSelector()}
		</Confirm>
	</>);
};


export default ProcessRequestConfirmation;